import React, { useCallback, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { TipTapEditor } from '../../../TipTap';
import { styled } from '@mui/material/styles';

const EditorWrapper = styled('div')(({ theme }) => ({
  width: '100%',
  '& .tiptap-editor-container': {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '6px',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.default,
  },
  '& .tiptap-editor-container:focus-within': {
    borderColor: theme.palette.text.secondary,
  },
  '& .tiptap-editor-content': {
    padding: '0 !important',
    minHeight: 'auto !important',
  },
  '& .ProseMirror': {
    fontSize: '12px',
    minHeight: '80px',
    padding: '8px 10px',
    outline: 'none',
    border: 'none',
    '& p': { margin: 0 },
    '& p + p': { marginTop: '4px' },
  },
}));

export default function RichTextPreview({ field, onUpdate, palette, theme, availablePlaceholders }) {
  const editorRef = useRef(null);

  const handleChange = useCallback(
    (val) => onUpdate({ defaultValue: val }),
    [onUpdate]
  );

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
    >
      <Typography sx={{ fontSize: '10px', color: palette.textSecondary, opacity: 0.7 }}>
        Pre-fill content (editable by the user)
      </Typography>
      <EditorWrapper>
        <TipTapEditor
          ref={editorRef}
          value={field.defaultValue || ''}
          onChange={handleChange}
          showToolbar={true}
          stripHtml={false}
          placeholder="Enter default content (optional)..."
          minHeight="80px"
          availablePlaceholders={availablePlaceholders}
        />
      </EditorWrapper>
    </Box>
  );
}
